import { Button, styled } from '@mui/material';
import Color from 'color';

export const StyledPrimaryButton = styled(Button, { name: 'StyledButton' })(({ theme }) => ({
  background: '#FF5A52',
  borderRadius: '7px',
  color: 'white',
  fontSize: '16px',
  padding: '0px',
  [theme.breakpoints.up('xs')]: {
    padding: '12px 22px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '4px',
    position: 'absolute',
    right: '16px',
    top: '8px',
    paddingRight: '8px'
  },

  '&:hover': {
    background: Color('#FF5A52').darken(0.2).hex()
  }
}));
